/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedRefineMenuSearchResults_itemFacetSearch$ref = any;
export type SbSharedRefineMenuSearchResults_itemFacetSearch = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly urlLabel: string | null;
            readonly linkReference: string | null;
            readonly displayName: string | null;
            readonly count: number | null;
        } | null;
    } | null> | null;
    readonly " $refType": SbSharedRefineMenuSearchResults_itemFacetSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuSearchResults_itemFacetSearch",
  "type": "ItemFacetsQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemFacetsQueryEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "FilterValueType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlLabel",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "linkReference",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "displayName",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "count",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '19d03bf6a33af25ed8d873fd082ae1cc';
export default node;
